import { IBookmarkReducerState } from "../Reducers/BookmarkReducer";
import { ICompanySupportTeamState } from "../Reducers/CompanySupportTeamReducer";
import { IDigitalShareReducer } from "../Reducers/DigitalShareReducer";
import { IGPSInsightsState } from "../Reducers/GPSInsightsReducer";
import { ILeftNavReducerState } from "../Reducers/LeftNavReducer";
import { ILoadScoutReducerState } from "../Reducers/LoadScoutReducer";
import { IMapSettingsReducerState } from "../Reducers/MapSettingsReducer";
import { IMobilyticsPlacesState } from "../Reducers/MobilyticsPlacesReducer";
import { IFactorState } from "../Reducers/FactorReducer";
import { IReportMapState } from "../Reducers/ReportMapReducer";
import { IReportReducerState } from "../Reducers/ReportsReducer";
import { IRetailMatchState } from "../Reducers/RetailMatchReducer";
import { ISalesPerformanceReducerState } from "../Reducers/SalesPerformanceReducer";
import { ISessionReducerState } from "../Reducers/SessionReducer";
import { ITerritoryManagementStore } from "../Reducers/TerritoryManagementReducer";
import { IToolboxReducerState } from "../Reducers/ToolboxReducer";
import { ITwoByTwoState } from "../Reducers/TwoByTwoReducer";
import { IUserManagementStore } from "../Reducers/UserManagementReducer";
import { IUserPreferencesStore } from "../Reducers/UserPreferencesReducer";
import { IUserProfileStore } from "../Reducers/UserProfileReducer";
import { IUserReducerState } from "../Reducers/UserReducer";
import { IAppReducerState } from "../View/Products/Reducers/AppReducer";
import { ILoginReducerState } from "../View/Products/Reducers/LoginReducer";
import { INotificationsReducerState } from "../View/Products/Reducers/NotificationsReducer";
import { IMyData, ITableau } from "./Models";
import { INotificationWorkflowReducerState } from "../Reducers/NotificationWorkflowReducer";

export interface IRootReducer {
  user: IUserReducerState;
  twoByTwo: ITwoByTwoState;
  mobilyticsReportOutput: IGPSInsightsState;
  factorReducer: IFactorState;
  matchReportOutput: IRetailMatchState;
  myData: IMyData;
  userPreferencesStore: IUserPreferencesStore;
  bookmarks: IBookmarkReducerState;
  loadScout: ILoadScoutReducerState;
  userManagement: IUserManagementStore;
  session: ISessionReducerState;
  tableauReducer: ITableau;
  reports: IReportReducerState;
  territoryManagement: ITerritoryManagementStore;
  userProfile: IUserProfileStore;
  companySupportTeamStore: ICompanySupportTeamState;
  salesPerformanceReducer: ISalesPerformanceReducerState;
  reportMap: IReportMapState;
  leftNav: ILeftNavReducerState;
  mapSettings: IMapSettingsReducerState;
  toolbox: IToolboxReducerState;
  mobilyticsPlaces: IMobilyticsPlacesState;
  digitalShare: IDigitalShareReducer;
  appReducer: IAppReducerState;
  loginReducer: ILoginReducerState;
  notificationsReducer: INotificationsReducerState;
  notificationWorkflowReducer: INotificationWorkflowReducerState;
}
